<template>
  <div class="client-invoices-content">
    <panel v-if="client" width="300">
      <div class="summary">
        <div> # invoices {{ invoices.length }}</div>
        <div> Total without VAT {{ invoicesSubTotal(invoices) }}</div>
        <div> Total with VAT {{ invoicesTotal(invoices) }}</div>
      </div>
    </panel>
    <invoice-list :invoices="invoices" :clients="clients" clientInvoice="true"></invoice-list>
  </div>
</template>

<script>
import Panel from "@/components/layout/Panel"
import InvoiceList from "@/components/invoice/InvoiceList";
export default {
  name: 'ClientInvoices',
  props: ['client', 'clients', 'invoices'],
  components: {
    Panel,
    InvoiceList
  },
  data() {
    return {
      

    }
  },
  computed: {
  },
  methods: {
    invoicesSubTotal(invoices){
      let total = 0
      for(let invoice of invoices){
        total += this.subTotal(invoice)
      }
      return total
    },
    invoicesTotal(invoices){
      let total = 0
      for(let invoice of invoices){
        total += this.total(invoice)
      }
      return total
    },
    subTotalWithoutDiscount(invoice) {
      let subTotal = 0;
      for (let article of invoice.articles) {
        subTotal += article.price_unit * article.quantity;
      }
      return +(Math.round(subTotal + "e+2") + "e-2");
    },
    discount(invoice) {
      if (invoice.discount) {
        return (this.subTotalWithoutDiscount(invoice) / 100) * invoice.discount;
      }
      return 0;
    },
    subTotal(invoice) {
      let subTotal = 0;
      if(invoice.articles){
        for (let article of invoice.articles) {
          subTotal += article.price_unit * article.quantity;
        }
      }
      return +(Math.round(subTotal - this.discount(invoice) + "e+2") + "e-2");
    },
    vat(invoice) {
      let vat = (this.subTotal(invoice) / 100) * invoice.vat_percentage;
      return +(Math.round(vat + "e+2") + "e-2");
    },
    total(invoice) {
      let total = this.subTotal(invoice) + this.vat(invoice);
      return +(Math.round(total + "e+2") + "e-2");
    },
    selectClientInvoice (invoice) {
      this.$store.dispatch('setSelectedClientInvoice', {invoice: invoice})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/colors";

.client-invoices-content {
  display: flex;
  align-items: flex-start;
}

</style>